// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Lf7H","left":"styles_left__3U3Nd"};